module.exports = __webpack_public_path__ + "img/darthvader.86ee3071.png";